module.exports = __webpack_public_path__ + "img/no-profile.a80b3039.jpg";